import { FunctionDTO } from "."

export const isRootRole = (role: string) => role === "SOURCE" || role === "SINK"

export const getRoles = (func: FunctionDTO) => {
  if (!func.role) return []

  return (Array.isArray(func.role) ? func.role : [func.role]).sort((a, b) => {
    if (isRootRole(a)) return 1
    if (isRootRole(b)) return -1

    return 0
  })
}

export const isRootFunction = (index: number, functions: FunctionDTO[]) =>
  index === 0 || index === functions.length - 1
